/*
 * File: \lib\native.js
 * File Created: 2022-05-07 16:29:29
 * Author: Ocean Li
 * -----
 * Last Modified: 2022-06-27 15:20:18
 * Modified By: Ocean Li ���
 */
import log from "./log.js";
import util from "./util.js";
import config from "../config.js";

const { info, warn, error } = log;
const { isMission } = util;

export default class Native {
  constructor(apis, event) {
    this.registerApis(apis);
    this.event = event;
  }

  cordovaExec(success, err, module, name, params = []) {
    if (typeof success !== "function")
      error(2002, "native cordovaExec success not function");
    if (typeof err !== "function")
      error(2002, "native cordovaExec error not function");
    if (!module) error(2002, "native cordovaExec module is a required");
    if (!name) error(2002, "native cordovaExec name is a required");
    if (!params) error(2002, "native cordovaExec params not array");
    console.log("cordovaExec", name, params);
    window.cordova && window.cordova.exec((data) => {
      console.log(`cordovaExec ${name} success`);
      this.event.triger(`${name}Success`, data);
      success(data);
    }, (e) => {
      console.log(`cordovaExec ${name} error`)
      this.event.triger(`${name}Error`, e);
      err(e);
    }, module, name, params);
  }

  get apiQueue() {
    if (!this._apiQueue) this._apiQueue = new Set();
    return this._apiQueue;
  }

  execApis() {
    const queue = this.apiQueue;
    queue.size &&
      queue.forEach(({ resolve, reject, module, name, params }) => {
        this.cordovaExec(resolve, reject, module, name, params);
      });
    // clear queue
    queue.clear();
  }

  apiCall(module, name, params = []) {
    return new Promise((resolve, reject) => {
      if (!window[config.cordovaReady] || window[config.cordovaReady] !== "1") {
        this.apiQueue.add({
          resolve,
          reject,
          module,
          name,
          params,
        });
        return;
      }
      this.cordovaExec(resolve, reject, module, name, params);
    });
  }

  apiBind(name, module) {
    return function(...params) {
      const self = this;
      if (params && params.length === 1 && Array.isArray(params[0])) {
        params = params[0];
      }
      return self.apiCall(module, name, params);
    }.bind(this);
  }

  get api() {
    if (!this._api) this._api = {};
    return this._api;
  }

  registerApi(module, name) {
    if (!module) {
      warn("native registerApi module is required");
      return;
    }
    if (!name) {
      warn("native registerApi name is required");
      return;
    }
    this.api[name] = this.apiBind(name, module);
  }

  registerApis(apis) {
    apis && apis.length && apis.forEach((api) => this.registerApi(...api));
  }

  addApis(apis) {
    this.registerApis(apis);
    return apis.map((api) => {
      return {
        name: api[1],
        fn: this.api[api[1]],
      };
    });
  }
}
